import {WB_EntityRow, WB_ProductGroupRow} from "../PA.Core/PAdbSchemaRows";
import {IHierarchyNodeProvider, INode, INodeLogicalKey} from "../PA.MD.Core/PA.MD.IF.Hierarchy";
import { esWB_Product_Group} from "../PA.Core/PAdbSchema";
import {ProductNodeProvider} from "./ProductNodeProvider";
import * as _ from "lodash";

export class ProductGroupNode
    implements INode
{
    private prodRow: WB_ProductGroupRow
    private prodProvider: ProductNodeProvider

    private _bUseLogicalKey: boolean
    private _logicalKey: INodeLogicalKey

    private bTypesLoaded: boolean
    private dctEntity: {[wbEntityId: number]: WB_EntityRow}

    constructor(prodRow: WB_ProductGroupRow, provider: ProductNodeProvider) {
        this.prodRow = prodRow
        this.prodProvider = provider

        this.bTypesLoaded = false
        this.dctEntity = {}

        this._bUseLogicalKey = (prodRow.cif.HIER_NODE_IND == '1')
        this._logicalKey = {}
        _.forEach(prodRow.WB_ProductGroupLogicalKeyRows, (a) => {
            if(!a.isActive)
                return
            let eLK: typeof this._logicalKey.a = {
                keyId: a.cif.KEY_ID,
                dataType: a.cif.DATATYPE
            }
            switch (eLK.dataType){
                case "entity":
                    eLK.valueWbId = a.cif.VALUE_WB_ID
                    eLK.valueWbEntityId = a.cif.VALUE_WB_ENTITY_ID
                    break
                case "number":
                    eLK.valueNumber = a.cif.VALUE_NUMBER
                    if(a.cif.VALUE_WB_ATTRIBUTEM_ID > 0)
                        eLK.valueWbAttributeMId  = a.cif.VALUE_WB_ATTRIBUTEM_ID
                    break
                case "string":
                    eLK.valueString = a.cif.VALUE_STRING
                    if(a.cif.VALUE_WB_ATTRIBUTEM_ID > 0)
                        eLK.valueWbAttributeMId  = a.cif.VALUE_WB_ATTRIBUTEM_ID
                    break
            }
            this._logicalKey[eLK.keyId] = eLK
        })

    }

    // Key
    get wbId(): number {
        return this.prodRow.cif.WB_PRDGRP_ID
    }

    get provider(): IHierarchyNodeProvider {
        return this.prodProvider
    }
    // Logical Identity
    get id_ui(): string { return this.prodRow.cif.PRODUCT_GROUP_ID }
    get key_set(): string { return this.prodRow.cif.PRODUCT_GROUP_SET_ID }

    get bUseLogicalKey(): boolean {
        return this._bUseLogicalKey
    }
    get logicalKey(): INodeLogicalKey {
        return this._logicalKey
    }

    // Storage, needed to determine
    get mapperName(): string { return esWB_Product_Group }

    // Other properties
    get node_name(): string { return this.prodRow.cif.PRODUCT_GROUP_NAME }

    isEntityType(wbEntityId: number, opts?: { wbSalesAreaIds?: number[] }): boolean {
        this.checkTypesLoaded()

        if(_.isEmpty(opts?.wbSalesAreaIds))
            return (wbEntityId in this.dctEntity)

        return false;
    }

    get entityTypes(): WB_EntityRow[] {
        this.checkTypesLoaded()

        return _.values(this.dctEntity)
    }


    private checkTypesLoaded(){
        if(this.bTypesLoaded)
            return

        // Use provider to create Dictionaries
        let dct = _.keyBy(this.provider.entityTypes, (a) => a.cif.META_WB_ID)

        if(this.prodRow.cif.WB_PRDM_ID in dct){
            let entity = dct[this.prodRow.cif.WB_PRDM_ID]
            this.dctEntity[entity.cif.WB_ENTITY_ID] = entity
        }

        this.bTypesLoaded = true

    }

}